/**
 * Courses
 */
export const CREATE_COURSE = "CREATE_COURSE";
export const URL_DISPONIBLE = "URL_DISPONIBLE";
export const COURSES_RECEIVED = "COURSES_RECEIVED";
export const MISCOURSES_RECEIVED = "MISCOURSES_RECEIVED";
export const SINGLE_COURSE_RECEIVED = "SINGLE_COURSE_RECEIVED";
export const SET_PROPERTY_COURSE = "SET_PROPERTY_COURSE";
